import React from "react";

export const Heart = () => (
  <svg viewBox="0 0 512 512">
    <path
      d="M146.39,41.04c41.87,1.27,74.63,12.9,102.21,37.4c5.75,5.11,8.98,6.13,15.58,0.48
	c88.77-76.06,221.13-31.31,244.51,83.12c10.48,51.27-4.08,96.75-40.78,133.94c-50.05,50.71-100.8,100.75-151.8,150.52
	c-32.11,31.33-86.47,33.19-118.56,2.02c-54.57-53-109.19-106.16-160.24-162.47c-41.96-46.29-47.59-102.39-21.54-158.78
	C42,70.46,89.72,43.6,146.39,41.04z"
    />
  </svg>
);
